import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import {
    SPONSORSHIP_BONUS_AMOUNT,
    SPONSORSHIP_BONUS_PERCENT,
    SPONSORSHIP_IS_BOOSTED_OPERATION,
    SPONSORSHIP_BOOSTED_OPERATION_END_DATE,
    SPONSORSHIP_BOOSTED_BONUS_AMOUNT
} from '../../../constants/sponsorship';
import { STATIC_ROOT } from '../../../constants';

import { toMoment, nowTimestamp } from '../../../utils/dateUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';

import './SponsorshipBanner.scss';

export class SponsorshipBanner extends React.Component {
    render() {
        const { i18n } = this.props;

        const isBoostedOperationActive =
            SPONSORSHIP_IS_BOOSTED_OPERATION &&
            SPONSORSHIP_BOOSTED_OPERATION_END_DATE &&
            toMoment(nowTimestamp()).isBefore(moment(SPONSORSHIP_BOOSTED_OPERATION_END_DATE));

        return (
            <div className="main-visual">
                <div className="wrapper">
                    <div className="bubbles">
                        <span>
                            {isBoostedOperationActive
                                ? convertHtmlToReactDomWithParams(i18n.BOOSTED_BUBBLE_TEXT)
                                : i18n.BUBBLE_TEXT}
                        </span>
                        <div>
                            <div className={`bubble ${isBoostedOperationActive ? 'boosted' : ''}`}>
                                <strong>
                                    <span>
                                        {isBoostedOperationActive
                                            ? convertHtmlToReactDomWithParams(
                                                  i18n.BOOSTED_BONUS_AMOUNT,
                                                  SPONSORSHIP_BOOSTED_BONUS_AMOUNT,
                                                  SPONSORSHIP_BONUS_AMOUNT
                                              )
                                            : convertHtmlToReactDomWithParams(
                                                  i18n.BONUS_AMOUNT,
                                                  SPONSORSHIP_BONUS_AMOUNT
                                              )}
                                    </span>
                                </strong>
                                <em className={`${isBoostedOperationActive ? 'boosted' : ''}`}>
                                    {i18n.BUBBLE2_TEXT1}
                                </em>
                                <span>{i18n.BUBBLE2_TEXT2}</span>
                                <span>&nbsp;</span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/sponsorship/diamond.svg`}
                                    className="euro"
                                    width="11"
                                    height="12"
                                />
                            </div>
                            <div className="bubble">
                                <strong>
                                    <span className="percent">{SPONSORSHIP_BONUS_PERCENT}</span>
                                    <span className="percent">%</span>
                                </strong>
                                <span>{i18n.BUBBLE1_TEXT1}</span>
                                <em>{i18n.BUBBLE1_TEXT2}</em>
                                <span>{i18n.BUBBLE1_TEXT3}</span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/sponsorship/diamond.svg`}
                                    className="percent"
                                    width="11"
                                    height="12"
                                />
                            </div>
                            <div className="more">
                                <p>+</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.SPONSORSHIP
    };
};

export default connect(mapStateToProps)(SponsorshipBanner);



// WEBPACK FOOTER //
// ./src/components/pages/sponsorship/SponsorshipBanner.js